import script from "./SecurePdfViewerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecurePdfViewerModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__